export default {

    SET_SELECT_CLUB_MANAGER({commit},ClubManager){
        commit('SET_SELECT_CLUB_MANAGER',ClubManager)
    },
    SET_RESULT({commit},result){
        commit('SET_RESULT',result)
    },
    SET_EDIT_CLUB_MANAGER({commit},editClubManager){
        commit('SET_EDIT_CLUB_MANAGER',editClubManager)
    },
}
